import { useState } from "react";

import Welcome from "./Welcome";
import Invite from "./Invite";
import Register from "./Register";
import Registered from "./Registered";
import FormSuccess from "./FormSuccess";

import { Container, Stack, Transition } from "@mantine/core";
import { TransitionDefault } from "../../../mantineTheme";
import { UserProps } from "types/module/User/Onboarding";

// 0. WELCOME
//     1. INVITE (Registered, w/ Invite)
//         1.1 INVITE_SENT (Invite Sent)
//     2. REGISTER (not Registered, w/out Invite)
//         2.1 REGISTER_EXIST (w/ auth0)
//         2.2 REGISTER_NEW (w/out auth0)
//     3. REGISTERED (Registered, w/out Invite)
//         3.1 REGISTERED_EXIST (w/ auth0)
//         3.2 REGISTERED_NEW (w/out auth0)

const USER_DEFAULT = {
  name: "",
  email: "",
  invitationId: null,
  invitationDate: null,
  isAuthUser: false,
};

const Onboarding: React.FC = () => {
  const [onboardStep, setOnboardStep] = useState<string>("WELCOME");
  const [user, setUser] = useState<UserProps>(USER_DEFAULT);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleRestartSteps = () => {
    setUser(USER_DEFAULT);
    setIsSubmitting(false);
    setOnboardStep("WELCOME");
  };

  return (
    <>
      <Stack
        justify="center"
        align="center"
        style={{ minHeight: "calc(100vh - 217px)" }}
      >
        <Transition {...TransitionDefault} mounted={onboardStep == "WELCOME"}>
          {(style) => (
            <Container size="xs" style={style}>
              <Welcome
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                setUser={setUser}
                setOnboardStep={setOnboardStep}
              />
            </Container>
          )}
        </Transition>
        <Transition {...TransitionDefault} mounted={onboardStep == "INVITE"}>
          {(style) => (
            <Container size="xs" style={style}>
              <Invite
                user={user}
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                setOnboardStep={setOnboardStep}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
        <Transition
          {...TransitionDefault}
          mounted={onboardStep == "INVITE_SENT"}
        >
          {(style) => (
            <Container size="xs" style={style}>
              <FormSuccess
                title="Invitation has been resent!"
                description={`The account is now being set up.
                  A confirmation email with access details for the DNA portal will be sent shortly. 
                  If you have any questions, feel free to contact support. Have a great day!`}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
        <Transition {...TransitionDefault} mounted={onboardStep == "REGISTER"}>
          {(style) => (
            <Container size="sm" style={style}>
              <Register
                user={user}
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                setOnboardStep={setOnboardStep}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
        <Transition
          {...TransitionDefault}
          mounted={onboardStep == "REGISTER_EXIST" || onboardStep == "REGISTER_NEW"}
        >
          {(style) => (
            <Container size="xs" style={style}>
              <FormSuccess
                title="Almost there..."
                description={`An account for ${user.name} is now being set up. 
                  They will receive an email shortly with instructions on how to access the DNA Portal.`}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
        <Transition
          {...TransitionDefault}
          mounted={onboardStep == "REGISTERED"}
        >
          {(style) => (
            <Container size="sm" style={style}>
              <Registered
                user={user}
                isSubmitting={isSubmitting}
                setIsSubmitting={setIsSubmitting}
                setOnboardStep={setOnboardStep}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
        <Transition
          {...TransitionDefault}
          mounted={onboardStep == "REGISTERED_EXIST" || onboardStep == "REGISTERED_NEW"}
        >
          {(style) => (
            <Container size="xs" style={style}>
              <FormSuccess
                title="Almost there..."
                description={`An account for ${user.name} is now being set up.
                  They will receive an email shortly with instructions on how to access the DNA Portal.`}
                restartSteps={handleRestartSteps}
              />
            </Container>
          )}
        </Transition>
      </Stack>
    </>
  );
};

export default Onboarding;
